// extracted by mini-css-extract-plugin
module.exports = {"support":"AltPage_support__HFSKb","featureImage":"AltPage_featureImage__U14TO","iframeContainer":"AltPage_iframeContainer__MBqeK","altHead":"AltPage_altHead___rL3x"};